import questionType from "./questionType";
export default {
  namespaced: true,
  state: {},
  actions: {
    // 添加问卷题目
    addEvaluation({ state }, type) {
      const queston_type = questionType.state.queston_type;
      switch (type) {
        case queston_type.EvaluationSCQ:
          return {
            type: queston_type.EvaluationSCQ,
            questionScore: 0, // 分数
            analysis: "", // 解析
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                  jump_title: "",
                  isCorrect: false,
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  jump_title: "",
                  isCorrect: false,
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  jump_title: "",
                  isCorrect: false,
                },
              ],
              count: 1, //单选多选
            }),
            status: "0", // 0创建页编辑中 1创建页显示操作 2创建页预览 3详情页预览 4详情页答题 5详情页显示答案
          };
        case queston_type.EvaluationMCQ:
          return {
            type: queston_type.EvaluationMCQ,
            questionScore: 0, // 分数
            analysis: "", // 解析
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                  isCorrect: false,
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  isCorrect: false,
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  isCorrect: false,
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  isCorrect: false,
                },
              ],
              maxCount: 1,
              minCount: 1,
            }),
            status: "0",
          };
        case queston_type.EvaluationWRQ:
          return {
            type: queston_type.EvaluationWRQ,
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", //  逻辑设置(question_id)
            questionScore: 0, // 分数
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  score: 1,
                },
                {
                  text: "",
                  score: 1,
                },
                {
                  text: "",
                  score: 1,
                },
              ],
            }),
            status: "0",
          };
        case queston_type.EvaluationScore:
          return {
            type: queston_type.EvaluationScore,
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            minScore: 1, // 起始分数
            scoreNum: 5, // 评分数量
            // elseConfig: JSON.stringify(["非常不满意", "一般", "非常满意"]),
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  ratingArr: ["非常不满意", "一般", "非常满意"],
                },
              ],
            }),
            status: "0",
          };
        case queston_type.EvaluationNPS:
          return {
            type: queston_type.EvaluationNPS,
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            caseProblemImg: JSON.stringify([]), //题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.TextDescription:
          return {
            type: queston_type.TextDescription,
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.NAME:
          return {
            type: queston_type.NAME,
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.GENDER:
          return {
            type: queston_type.GENDER,
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "男",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "女",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0",
          };
        case queston_type.AGE:
          return {
            type: queston_type.AGE,
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "18岁以下",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "18~35岁",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "35~60岁",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "60岁以上",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0",
          };
        case queston_type.ELQ:
          return {
            type: queston_type.ELQ,
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "初中及以下",
                },
                {
                  text: "高中/中专/技校",
                },
                {
                  text: "大学专科",
                },
                {
                  text: "大学本科",
                },
                {
                  text: "硕士及以上",
                },
              ],
            }),
            status: "0",
          };
        case queston_type.DATE:
          return {
            type: queston_type.DATE,
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.ADDR:
          return {
            type: queston_type.ADDR,
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            mapAccuracy: 3, // 0 选择地址精度 1 精确到省 2 精确到市 3 精确到区 4 精确到详细地址
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", //  逻辑设置(question_id)
            status: "0",
          };
        case queston_type.Industry:
          return {
            type: queston_type.Industry,
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.Occupation:
          return {
            type: queston_type.Occupation,
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };

        case queston_type.SBQ:
          return {
            type: queston_type.SBQ,
            questionScore: 0, // 分数
            analysis: "", // 解析
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            fillSymbol: 3, // 填空符数量
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseAnswer: "", // 正确答案
            scoringMethod: 0, // 评分方式
            status: "0",
          };
        case queston_type.MBQ:
          return {
            type: queston_type.MBQ, // 多项填空
            questionScore: 0, // 分数
            analysis: "", // 解析
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  img_path: [],
                  correct_answer: "",
                },
                {
                  text: "",
                  img_path: [],
                  correct_answer: "",
                },
                {
                  text: "",
                  img_path: [],
                  correct_answer: "",
                },
              ],
            }),
            scoringMethod: 0, // 评分方式
            status: "0",
          };
        case queston_type.Customize:
          return {
            type: queston_type.Customize, // 自定义
            questionScore: 0, // 分数
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.EvaluationMatrixSCQ:
          return {
            type: queston_type.EvaluationMatrixSCQ,
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), //题目图片["img地址"]
            questionScore: 0, // 分数
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  id: "", //选项ID
                  context: "",
                },
                {
                  id: "", //选项ID
                  context: "",
                },
                {
                  id: "", //选项ID
                  context: "",
                },
              ],
              verticalNum: 3, //竖列 2-3
              // 满意,不满意,中立
              percentageTitle: "", //竖列标题
              // 横标题
              horizontalTitle: "",
            }),
            isMust: 1, // 是否必填  0否 1是
            status: "0", // 0创建页编辑中 1创建页显示操作 2创建页预览 3详情页预览 4详情页答题
          };
        case queston_type.ImageOrVideo:
          // 图片/视频
          return {
            type: queston_type.ImageOrVideo, // 图片/视频
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            caseProblemImg: JSON.stringify([]), //题目图片["img地址"]
            chooseList: JSON.stringify({
              list: [
                {
                  url: "", // 图片/视频地址
                  type: "",
                },
              ],
            }),
            isMust: 1, // 是否必填  0否 1是
            status: "0",
          };
        case queston_type.Audio:
          return {
            type: queston_type.Audio,
            caseProblem: "",
            questionScore: 0, // 分数
            ifRandomize: 0,
            caseProblemImg: JSON.stringify([]),
            isMust: 1,
            chooseList: JSON.stringify({ list: [] }),
            status: "0",
          };
        default:
          break;
      }
    },
  },
  getters: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/moduleEvaluation.js